import { createWebHistory, createRouter } from "vue-router";
// import {loadLayoutMiddleware} from './loadLayoutMiddleware.js'
import axios from "axios";
import HomeView from "./components/HomeView.vue";
import MainView from "./components/main.vue";
import ArchiveView from "./components/archive.vue";
import SignView from "./components/sign.vue";
import SuccessView from "./components/success.vue";
import FailedView from "./components/failed.vue";
import ResultView from "./components/result.vue";
import verificationView from "./components/verification.vue";

let contract = {};
let attachments = {};

//驗證Token
async function validateToken(token) {
  const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  try {
    const res = await api.post("/api/v1/signings/auth");
    return res.status === 204 || res.status === 200;
  } catch (error) {
    console.log(
      "Validation error:",
      error.response ? error.response.data : error.message
    );
    return false;
  }
}
async function validateChecksumData(to) {
  const token = localStorage.getItem("token");

  const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  try {
    const response = await api.get(
      `/api/v1/digital_contract/checksum_is_valid/${to.params.uuid}/${to.params.checksum}.json`
    );
    // console.log("validateChecksum res", response);.checksum_is_valid
    return response.data;
  } catch (error) {
    console.log(
      "Validation error:",
      error.response ? error.response.data : error.message
    );
    return false;
  }
}


async function validateIsSigned(to, from, next) {
  const token = localStorage.getItem("token");

  const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  try {
    const response = await api.get(
      `/api/v1/signing_digital_contract/${to.params.uuid}/${to.params.sgid}/${to.params.checksum}.json`
    );
    if (response.data.signed) {
      next({
        path: "/sign/result",
        query: {
          isSigned: true,
        },
      });
    } else {
      next();
    }
  } catch (error) {
    console.error(
      "Validation error:",
      error.response ? error.response.data : error.message
    );
    return false;
  }
}

async function getContract(to, from, next) {
  const token = localStorage.getItem("token");
  const isValid = await validateToken(token);
  let checksumIsValid = false;
  try {
    const checksumIsValidData = await validateChecksumData(to); // 使用 await 等待异步结果
    checksumIsValid = checksumIsValidData.checksum_is_valid
  } catch (error) {
    console.error("Checksum validation failed:", error);
  }

  if (!checksumIsValid) {
    console.log("getContract Checksum is invalid");
    next({
      path: "/sign/result",
      query: {
        // isSigned: false,
        checksumIsValid: false,
      },
    });
  } else if (isValid) {
    // 继续获取 Contract
    const api = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
      const response = await api.get(
        `/api/v1/signing_digital_contract/${to.params.uuid}/${to.params.sgid}/${to.params.checksum}.json`
      );
      contract = await response.data.digital_contract;
      attachments = await response.data.attachments;
      // console.log('contract', contract);
      // console.log('attachments', attachments);

      if (response.status === 200) {
        to.params.contract = contract;
        to.params.attachments = attachments;
        next();
      } else {
        next(
          `/verification/${to.params.uuid}/${to.params.sgid}/${to.params.checksum}`
        );
      }
    } catch (error) {
      console.error(
        "Error in route:",
        error.response ? error.response.data : error.message
      );
      next(
        `/verification/${to.params.uuid}/${to.params.sgid}/${to.params.checksum}`
      );
    }
  } else {
    next(
      `/verification/${to.params.uuid}/${to.params.sgid}/${to.params.checksum}`
    );
  }
}

const routes = [
  {
    path: "/signing_digital_contract/:uuid/:sgid/:checksum",
    name: "main",
    component: MainView,
    beforeEnter: getContract,
    props: true,
    meta: { layout: "DefaultLayout", requiresAuth: true },
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    meta: { layout: "HomeLayout" },
  },
  {
    path: "/archives/:uuid/:sgid/:checksum",
    name: "archive",
    component: ArchiveView,
    beforeEnter: getContract,
    props: true,
    meta: { layout: "DefaultLayout", requiresAuth: true },
  },
  {
    path: "/sign/:uuid/:sgid/:checksum",
    name: "sign",
    component: SignView,
    beforeEnter: validateIsSigned,
    meta: { layout: "DefaultLayout", requiresAuth: true },
  },
  {
    path: "/sign/success",
    name: "success",
    component: SuccessView,
    meta: { layout: "DefaultLayout", skipValidate: true },
  },
  {
    path: "/sign/failed",
    name: "failed",
    component: FailedView,
    meta: { layout: "DefaultLayout", skipValidate: true },
  },
  {
    path: "/sign/result",
    name: "result",
    component: ResultView,
    props: (route) => ({
      isSigned: route.query.isSigned,
      checksumIsValid: route.query.checksumIsValid,
      isLastest: route.query.isLastest,
    }),
    meta: { layout: "DefaultLayout", skipValidate: true },
  },
  {
    path: "/verification/:uuid/:sgid/:checksum",
    name: "verification",
    component: verificationView,
    meta: { layout: "HomeLayout" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.skipValidate) {
    next();
    return;
  }
  const uuid = to.params.uuid;
  const sgid = to.params.sgid;
  const checksum = to.params.checksum;

  let checksumIsValid = false;
  let contractIsLatest = true;
  try {
    const checksumIsValidData = await validateChecksumData(to); // 使用 await 等待异步结果
    checksumIsValid = checksumIsValidData.checksum_is_valid
    contractIsLatest = checksumIsValidData.latest
    console.log("判斷checksumIsValid at router.beforeEach", checksumIsValid);
    console.log("判斷contractIsLatest at router.beforeEach", contractIsLatest);
  } catch (error) {
    console.log("Checksum validation failed:", error);
  }
  // 是否contract最新版本

  if (!checksumIsValid) {
    next({
      path: "/sign/result",
      query: {
        isSigned: false,
        checksumIsValid: false,
      },
    });
  } else if (!contractIsLatest){
    next({
      path: "/sign/result",
      query: {
        isLastest: false,
      },
    });
  } else if (to.meta.requiresAuth) {
    const token = localStorage.getItem("token");
    const isValid = await validateToken(token);
    if (isValid) {
      next();
    }
    else {
    //如果路由需要验证token，并且token不存在，则重定向到登录页面
      next(`/verification/${uuid}/${sgid}/${checksum}`);
    }
  } else {
    next();
  }
});

export default router;
